import { ClinicianLeaderboard } from "@/features/admin/components/ClinicianLeaderboard";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/customers/clinicians")({
    component: CustomerCliniciansPage,
});

function CustomerCliniciansPage() {
    useNav([
        { label: "Customers", route: { to: "/customers/success" } },
        { label: "Clinicians", route: { to: "/customers/clinicians" } },
    ]);

    return <ClinicianLeaderboard />;
}
